import { AppState } from '../../types';

export const selectIsNeedCloseModal = (state: AppState): boolean => state.modal.needClose;
